export default __webpack_public_path__ + "static/media/logo-white.a722d1f1.svg";